import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppAuthGuard } from './app-auth.guard';


const routes: Routes = [
  {
    path: '',
    canActivate: [AppAuthGuard],
    children: [
      {
        path: 'scheduler',
        loadChildren: () => import('./m/scheduler/scheduler.module')
          .then(m => m.SchedulerModule)
      },
      {
        path: 'group-management',
        loadChildren: () => import('./m/group-management/group-management.module')
          .then(m => m.GroupManagementModule)
      },
      {
        path: 'channels',
        loadChildren: () => import('./m/channels/channels.module')
          .then(m => m.ChannelsModule)
      },
      {
        path: 'fragments',
        loadChildren: () => import('./m/fragments/fragments.module').then((m) => m.FragmentsModule),
      },
      {
        path: '**',
        redirectTo: 'channels',
        pathMatch: 'full'
      },
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {
      bindToComponentInputs: true,
      enableTracing: /* !env.production */ false
    })
  ],
  exports: [RouterModule],
  providers: [AppAuthGuard]
})
export class AppRoutingModule { }
